import { call, select, sleep, takeLeading } from "starfx";

import i18n from "@app/i18n";
import { runThunk, safeLast } from "@app/statefx/helpers";
import { processLoadLists } from "@app/statefx/routines/mapperfn-listdefinition";

import { isErr } from "../helpers";
import { schema } from "../schema";
import { xApi, xWorker } from "../xapis";
import { sfxNotify } from "./notify";
import { uiSetDefaultIssuer } from "./uiSpvMain";

import type { ApiCtx, Next } from "starfx";
import type { TDBAccount } from "@app/types/insider";
import type { TIssuerAsContractor } from "@app/types/insider";
const t = i18n.t.bind(i18n);
const db = schema;

// get-wait (optimistic):: give from stored cache/idb then fetch and remake cache/idb
//
export const sfxGetInvoiceIssuers = xWorker.get(
  "/wait/getInvoiceIssuers",
  // get-wait
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/db/dbof_emitenti",
    });
    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("ctx", ctx);
      console.log("getInvoiceIssuers: error in data", data);
      return;
    }
    const dataMap = data.value.reduce((acc, rec) => {
      if (!rec["CIF"]) {
        return acc;
      }
      rec["shid0"] = "nop";
      rec["shid1"] = "nop";
      rec["_hkey"] = null;
      rec["_hvalue"] = null;
      acc[rec["CIF"]] = rec;
      return acc;
    }, {});
    yield* schema.update(db.invoiceIssuer.set(dataMap));
    // run side effect
    yield* call(uiSetDefaultIssuer.run(dataMap));
  }
);

// const applyReadonly = (x: IDBLxReportOption, meAmaId: number) => {
//   if (x.READONLY || x.GROUP_DISPLAY_NAME === CONST_LSTGRP_IMPLICIT) {
//     return true;
//   }
//   if (x.OWNER_AMA === meAmaId) {
//     return false;
//   }
//   return Boolean(+x.READONLY);
// };

// const blobState = (blob: string) => {
//   try {
//     return JSON.parse(blob);
//   } catch (e) {
//     return {};
//   }
// };

// const processLoadLists = (
//   data: IDBLxReportOption[],
//   meAmaId: number,
// ): MapEntity<ILxReportOption> => {
//   return compose(
//     keyBy((x: ILxReportOption) => x.id),
//     map((item: IDBLxReportOption) => {
//       const blob = blobState(item.B_GRIDSTATE);
//       return {
//         id: item.KLR_ID,
//         group: item.KLR_GROUP,
//         name: item.LIST_NAME,
//         displayName: item.LIST_DISPLAY_NAME,
//         displayGroup: item.GROUP_DISPLAY_NAME,
//         // liGroups.find((x) => x.id === item.KLR_GROUP)
//         //   ?.name as TLxReportDisplayGroup,
//         text: item.TEXT,
//         access: item.ACCESS,
//         readonly: applyReadonly(item, meAmaId),
//         ownerAma: item.OWNER_AMA,
//         selectionOptions: blob?.selectionOptions || {},
//         state: blob,
//         params_default: {},
//         params_mandatory: [],
//         params_optional: [],
//       };
//     }),
//   )(data);
// };
// function* identityACtx(ctx: ApiCtx) {
//   yield* sleep(1);
//   return ctx;
// }

export const getListDefinition = xApi.get(
  "sfx/reports/listrepordef",
  { supervisor: takeLeading },
  function* (ctx, next) {
    ctx.request = ctx.req({
      url: "/reports/listreportdetails",
      method: "get",
    });
    yield* next();

    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      return;
    }
    const _meAma = yield* select(schema.whoami.select);
    const meAma = +_meAma.AmaId;
    yield* schema.update(
      schema.listModels.set(processLoadLists(data.value, meAma))
    );
  }
);

export const sfxFetchAccounts = xWorker.get(
  "/wait/sfx/select/accounts",
  { supervisor: takeLeading },
  function* (ctx, next) {
    // yield* put(repo_accounts.actions.reset());
    yield* schema.update(schema.issuerBankAccounts.reset());
    ctx.request = ctx.req({
      url: "/select/accounts",
      method: "get",
    });

    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      return;
    }
    //Some mappings ....
    const dataset = data.value.reduce((acc: any, account: TDBAccount) => {
      acc[account.CONTMA_ID] = account;
      return acc;
    }, {});
    yield* schema.update(schema.issuerBankAccounts.set(dataset));
  }
);

/* 
SELECT CIF_NRRC_DUPLICAT
FROM SALVARE_EMITENT_V2( :E_ID, :DENUMIRE, :ABR, :ADRESA, :CIF, :NRRC, :CAPITAL_SOCIAL, :ADRESA_LINIA_1, :ADRESA_LINIA_2,
   :ADRESA_LINIA_3, :ADRESA_LINIA_4, :COD_POSTAL, :COD_TARA, :ALIAS, :COD_JUDET, :ORAS, :INATENTIA, :FAX, :TELEFON, :EMAIL,
    :TVA_LA_INCASARE, :TVA_LA_FACTURARE, :CONTMA_PRINCIPAL);

*/

// function mapEmitentToContractor(
//   emitent: TEmitent,
//   account: TDBAccount,
//   cifLocked: boolean,
// ): TIssuerAsContractor {
//   return {
//     __type: 'EMITENT',
//     __messageID: -1, // Set default or generate appropriately
//     CONTMA_PRINCIPAL: account.CONTMA_ID,
//     __cifLocked: cifLocked,
//     CffId: emitent.E_ID,// important
//     ClientName: emitent.DENUMIRE,
//     Address: `${emitent.ADRESA_LINIA_1} ${emitent.ADRESA_LINIA_2}`,
//     __address__continuation: `${emitent.ADRESA_LINIA_3} ${emitent.ADRESA_LINIA_4}`,
//     County: emitent.COD_JUDET,
//     RegistrationNumber: emitent.NRRC,
//     TaxCode: emitent.CIF,
//     Iban: account.NR_CONT,
//     BankName: account.BANCA,
//     Attention: emitent.INATENTIA,
//     Phone: emitent.TELEFON,
//     Fax: emitent.FAX,
//     ClientId: 0, // Set default or derive as needed
//     AmaIdIns: 0, // Set default or derive as needed
//     City: emitent.ORAS,
//     CountryCode: emitent.COD_TARA,
//     CountyCode: emitent.COD_JUDET,
//     Email: emitent.EMAIL,
//     PostalCode: emitent.COD_POSTAL,
//     AdditionalAddress: '',
//     BuyerReference: '',
//     UsingRoEfactura: 0,
//     VATOnCashAccounting: emitent.TVA_LA_INCASARE,
//     VATOnInvoiceAccounting: emitent.TVA_LA_FACTURARE,
//   };
// }

function mapIssuerAsContractorToQueryParams(issuer: TIssuerAsContractor) {
  console.log("issuer", issuer);
  return {
    E_ID: issuer.CffId, // important
    DENUMIRE: issuer.ClientName,
    ABR: issuer.ClientCode,
    ADRESA: issuer.Address,
    CIF: issuer.TaxCode,
    NRRC: issuer.RegistrationNumber,
    CAPITAL_SOCIAL: issuer.CAPITAL_SOCIAL,
    ADRESA_LINIA_1: issuer.Address || "",
    ADRESA_LINIA_2: "",
    ADRESA_LINIA_3: issuer.__address__continuation || "",
    ADRESA_LINIA_4: "",
    COD_POSTAL: issuer.PostalCode,
    COD_TARA: issuer.CountryCode,
    ALIAS: "",
    COD_JUDET: issuer.CountyCode,
    ORAS: issuer.City,
    INATENTIA: issuer.Attention,
    FAX: issuer.Fax,
    TELEFON: issuer.Phone,
    EMAIL: issuer.Email,
    TIP_PLATA_TVA: issuer.TIP_PLATA_TVA,
    CONTMA_PRINCIPAL: issuer.CONTMA_PRINCIPAL,
    // Note: If there are other fields that don't directly map, you'll need to handle them accordingly.
  };
}

function* parseableCtx(ctx: ApiCtx) {
  yield* sleep(1);
  return ctx.json;
}

export const saveInvoiceIssuerToDb = xApi.post<TIssuerAsContractor>(
  "/xApi/insider/saveInvoiceIssuerToDb",
  { supervisor: takeLeading },
  function* (ctx, next) {
    const mappedPayload = mapIssuerAsContractorToQueryParams(ctx.payload);
    const msg = [];
    if (!mappedPayload.E_ID) {
      msg.push(t("issuerIdIsRequired"));
    }
    if (!mappedPayload.CIF) {
      msg.push(t("taxCodeIsRequired"));
    }
    if (mappedPayload.DENUMIRE === "") {
      msg.push(t("clientNameIsRequired"));
    }
    if (mappedPayload.ABR === "") {
      msg.push(t("clientCodeIsRequired"));
    }
    if (![-1, 0, 1].includes(mappedPayload.TIP_PLATA_TVA)) {
      msg.push(t("addressIsRequired"));
    }
    if (msg.length > 0) {
      yield* runThunk(sfxNotify, {
        message: msg.join("\n"),
        type: "error",
        position: "top",
        duration: 3000,
      });
      yield* sleep(3_000);
      return;
    }

    ctx.request = ctx.req({
      url: "/select/salvare_emitent_v2",
      headers: {
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify({ data: mappedPayload }),
    });
    yield* next();
    console.log("ctx", ctx);
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      yield* runThunk(sfxNotify, {
        message: data.error.message,
        type: "error",
        position: "top",
        duration: 3000,
      });
      return;
    }
    yield* runThunk(sfxNotify, {
      message: t("issuerSaved"),
      type: "success",
      position: "top",
      duration: 3000,
    });

    yield* call(sfxGetInvoiceIssuers.run());

    yield* next();
  }
);

const mapAccRecord = (account: TDBAccount) => {
  return {
    P_CONTMA_ID: account.CONTMA_ID,
    P_NR_CONT: account.NR_CONT,
    P_BANCA: account.BANCA,
    P_MONEDA: account.MONEDA,
    P_OBSERVATII: account.OBSERVATII,
    P_SOCIETATEA: account.SOCIETATEA,
    P_NICK: account.NICK,
    P_EID: account.EID,
    P_ADRESA: account.ADRESA,
    P_SWIFT: account.SWIFT,
    P_BANCA_CRSP: account.BANCA_CRSP,
    P_ACTIV: account.ACTIV ? 1 : 0,
    P_CONT_IMPLICIT: account.CONT_IMPLICIT ? 1 : 0,
  };
};

export const sfxInserOrUpdateAccount = xApi.post<TDBAccount>(
  "/sfx/inserOrUpdateAccount",
  { supervisor: takeLeading },
  function* (ctx, next) {
    ctx.request = ctx.req({
      url: "/select/insert_or_update_contma",
      headers: {
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify({ data: mapAccRecord(ctx.payload) }),
    });
    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      return;
    }
    yield* call(sfxFetchAccounts.run());
  }
);
